/**
 * Formatting helpers for policy-derived numbers (waiting allowance / rate).
 *
 * Policy values arrive raw — e.g. a 50-second free-waiting allowance becomes
 * `50 / 60 = 0.8333…` minutes, and rates can produce long fractional dollars.
 * Always clamp any such conversion to a single decimal before it reaches the UI
 * so users never see "0.8333333333333334 minutes".
 */
import {formatDHM} from '@/utils/dateUtils';

/** Round to at most 1 decimal place (0.8333… → 0.8, 72 → 72, 1.25 → 1.3). */
export function round1(value) {
  return Math.round((Number(value) || 0) * 10) / 10;
}

/**
 * Buffer label from raw minutes for the smart-suggestion airport buffers
 * (/config/app): whole hours → "3 h", hours + remainder → "1 h 30 min",
 * under an hour → "45 min".
 */
export function formatBufferApprox(minutes) {
  return formatDHM(minutes);
}

export default round1;
